module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_07_sp-30b4a48aac6eb0fb402e8511e3752657.png";